
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gizlilik-sozlesmesi",
      function () {
        return require("private-next-pages/gizlilik-sozlesmesi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gizlilik-sozlesmesi"])
      });
    }
  